import { render } from "./Hero.vue?vue&type=template&id=710fe0e6&scoped=true"
const script = {}

import "./Hero.vue?vue&type=style&index=0&id=710fe0e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710fe0e6"]])

export default __exports__